module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAAAXNSR0IArs4c6QAAAC5JREFUOBFjXPpixX+GAQBMA2An2MpRi+kW8qNBPRrUNAuB0cRFs6BFN3jkBTUAIAwDUuAPn7QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/target.png
// module id = 704
// module chunks = 1